import * as fetch from './fetch'

export function getCompany(id, token) {
  const endpoint = '/companies/' + id
  return fetch.GET(endpoint, token, true)
}

export function getCompanySubscription(id, token) {
  const endpoint = '/companies/' + id + '/subscription';
  return fetch.GET(endpoint, token, true)
}

export function deleteCompany(id, token) {
  const endpoint = '/companies/' + id;
  return fetch.DELETE(endpoint, token, true);
}

export function fullRegistration(fullRegistrationRequest, token) {
  const endpoint = '/companies/fullRegistration';
  return fetch.POST(endpoint, token, fullRegistrationRequest);
}

export function addCompanyKey(companyId, companyKeyRequest, serviceName, token) {
  const endpoint = `/companies/${companyId}/apiKey/${serviceName}`;
  return fetch.POST(endpoint, token, companyKeyRequest);
}

export function changeCompanyKeys(companyId, companyKeyRequest, serviceName, token) {
  const endpoint = `/companies/${companyId}/apiKey/${serviceName}`;
  return fetch.PUT(endpoint, token, companyKeyRequest);
}

export function getList(options, token) {
  let parameters = mapToParameters(options)

  const endpoint = '/companies'
  let queryString = new URLSearchParams(parameters).toString()
  return fetch.GET(endpoint + '?' + queryString, token, true)
}

export function getTempCompaniesList(options, token) {
  let parameters = mapToParameters(options)

  const endpoint = '/companies/temp';
  let queryString = new URLSearchParams(parameters).toString();
  return fetch.GET(endpoint + '?' + queryString, token, true);
}

export function getOtherVendorsCompaniesList(options, token) {
  let parameters = mapToParameters(options)

  const endpoint = '/companies/otherVendors'
  let queryString = new URLSearchParams(parameters).toString()
  return fetch.GET(endpoint + '?' + queryString, token, true)
}

export function getPreInvoiceAccountings(companyId, dueDate, token) {
  const endpoint = `/companies/${companyId}/accountings?dueDate=${dueDate}`;
  return fetch.GET(endpoint, token, true);
}


export function getTempCompany(tempCompanyId, token) {
  const endpoint = `/companies/temp/${tempCompanyId}`;
  return fetch.GET(endpoint, token, true);
}

export function addTempCompanyKey(tempCompanyId, companyKeyRequest, token) {
  const endpoint = `/companies/temp/${tempCompanyId}/apiKey`;
  return fetch.POST(endpoint, token, companyKeyRequest);
}

export function putTempCompany(tempCompanyId, updatedCompany, token) {
  const endpoint = `/companies/temp/${tempCompanyId}`;
  return fetch.PUT(endpoint, token, updatedCompany);
}

export function getUsageStatsForCompany(companyId, token) {
  const endpoint = '/stats/ofCompany/' + companyId;
  return fetch.GET(endpoint, token, true)
}

export function changeName(companyId, newCompanyName, token) {
  const endpoint = `/companies/${companyId}/companyName`;
  let body = {
    name: newCompanyName
  };

  return fetch.PUT(endpoint, token, body, true);
}

export function modifyIndustry(companyId, newIndustryId, token) {
  const endpoint = `/companies/${companyId}/industry`;
  let body = {
    industryId: newIndustryId
  };

  return fetch.PUT(endpoint, token, body, true);
}

export async function exportAdvancedSearch(filters, token) {
  const endpoint = '/companies/export';
  let queryString = new URLSearchParams(filters).toString();
  return fetch.GET(endpoint + '?' + queryString, token, true);
}

export function advancedSearch(options, filters, token) {
  let parameters = mapToParameters(options);

  // BASIC FILTERS
  if (filters.query) {
    parameters.query = filters.query;
  }

  if (filters.email) {
    parameters.email = filters.email;
  }

  if (filters.town) {
    parameters.town = filters.town;
  }

  if (filters.status !== null && filters.status !== undefined) {
    parameters.status = filters.status;
  }

  // REGISTRATION DATES
  if (filters.registrationDateFrom) {
    parameters.registrationDateFrom = filters.registrationDateFrom;
  }

  if (filters.registrationDateTo) {
    parameters.registrationDateTo = filters.registrationDateTo;
  }

  // ACTIVATION DATES
  if (filters.activationDateFrom) {
    parameters.activationDateFrom = filters.activationDateFrom;
  }

  if (filters.activationDateTo) {
    parameters.activationDateTo = filters.activationDateTo;
  }

  // SUBSCRIPTION FILTERS
  if (filters.serviceType !== null && filters.serviceType !== undefined) {
    parameters.serviceType = filters.serviceType;
  }

  if (filters.plan !== null && filters.plan !== undefined) {
    parameters.plan = filters.plan;
  }

  if (filters.lastUsage !== null && filters.lastUsage !== undefined) {
    parameters.lastUsage = filters.lastUsage;
  }

  const endpoint = '/companies/search';

  let queryString = new URLSearchParams(parameters).toString();

  return fetch.GET(
    endpoint + '?' + queryString,
    token,
    true
  );
}

function mapToParameters(options) {
  let parameters = {}

  if (options.page !== null) {
    parameters.pageNum = options.page
  }

  if (options.itemsPerPage !== null) {
    parameters.pageSize = options.itemsPerPage
  }

  // if (options.search) {
  //   parameters.query = options.search
  // }

  return parameters
}
